import React, { useState } from "react";

import activeLibrary from "../assets/icons/bold/Document.svg";
import inactiveLibrary from "../assets/icons/lightOutline/Document.svg";

import headphones_active from "../assets/iconsV2/headphones.svg";
import headphones_inactive from "../assets/iconsV2/headphones_not.svg";

import profileActive from "../assets/icons/bold/Profile.svg";
import profileInactive from "../assets/icons/lightOutline/Profile.svg";
import MiniPlayer from "./MiniPlayer";

const FooterNav = ({ activeTab, handleTabChange, bookId, userProfilePicture, centerText }) => {
    const [isPlayerExpanded, setIsPlayerExpanded] = useState(false);

    return (
        <div
            className={`fixed bottom-0 left-0 right-0 w-full mt-1 flex flex-col items-center bg-white z-50
            ${isPlayerExpanded ? 'h-screen rounded-none' : 'py-4'} ${bookId ? 'rounded-none mt-0 pt-0' : 'rounded-t-[8vw]'}`}
        >
            {bookId && (
                <MiniPlayer bookId={bookId} onExpandChange={setIsPlayerExpanded} isSongTab={centerText === "Күйтабақ"} />
            )}

            {!isPlayerExpanded && (
                <div className="flex justify-around items-center w-full">
                    <button onClick={() => handleTabChange("library")} className="flex flex-col items-center">
                        <img src={activeTab === "library" ? activeLibrary : inactiveLibrary} alt="Library" className="w-6 h-6 mb-1" />
                    </button>

                    <button onClick={() => handleTabChange("home")} className="flex flex-col items-center">
                        <img src={activeTab === "home" ? headphones_active : headphones_inactive} alt="Home" className="w-6 h-6 mb-1" />
                        <span className="text-sm text-gray-800">
                            {centerText || "Кітаптар"}
                        </span>
                    </button>

                    <button onClick={() => handleTabChange("profile")} className="flex flex-col items-center">
                        {userProfilePicture ? (
                            <img
                                src={userProfilePicture}
                                alt="User"
                                className={`w-6 h-6 mb-1 rounded-full border-2 ${activeTab === 'profile' ? 'border-blue-500' : 'border-gray-300'}`}
                            />
                        ) : (
                            <img
                                src={activeTab === "profile" ? profileActive : profileInactive}
                                alt="Profile"
                                className="w-6 h-6 mb-1"
                            />
                        )}
                    </button>
                </div>
            )}
        </div>
    );
};

export default FooterNav;